module.exports = __webpack_public_path__ + "img/tarj1-1.89741fb0.svg";